/** @jsxImportSource theme-ui */
import { gql } from "@apollo/client";
import { Trans } from "@lingui/macro";
import "@reach/dialog/styles.css";
import { graphql } from "~/gql";
import { Chats } from "@phosphor-icons/react";
import { useState } from "react";
import useLocale from "../../useLocale";
import { useCollection } from "../SiteSearch/useEventData";
import type { ActionButtonProps } from "../ActionButton";
import ActionButton from "../ActionButton";
import useSiteConfig from "../useSiteConfig";
import type { RequestChatButtonDialogData } from "./RequestChatButton.Dialog";
import RequestChatButtonDialog from "./RequestChatButton.Dialog";

type ChatButtonProps = Omit<ActionButtonProps, "children"> & {
  profile: RequestChatButtonDialogData;
};

/** A chat button that triggers the "start a chat" request flow. */
export default function RequestChatButton({
  profile,
  ...rest
}: ChatButtonProps) {
  const { isChatEnabled } = useSiteConfig();
  const [isOpen, setOpen] = useState(false);
  const { collectionId } = useCollection();
  const locale = useLocale();
  if (!isChatEnabled) return null;
  return (
    <ActionButton onClick={() => setOpen(true)} {...rest}>
      <Chats size={16} weight="light" />
      <Trans>Chat</Trans>
      {isOpen && (
        <RequestChatButtonDialog
          collectionId={collectionId}
          locale={locale || "en"}
          profile={profile}
          onDismiss={() => setOpen(false)}
          isOpen={isOpen}
        />
      )}
    </ActionButton>
  );
}

export function RequestChatButtonSkeleton(
  rest: Omit<ActionButtonProps, "children">
) {
  const { isChatEnabled } = useSiteConfig();
  if (!isChatEnabled) return null;
  return (
    <ActionButton disabled {...rest}>
      <Chats size={16} weight="light" />
      <Trans>Chat</Trans>
    </ActionButton>
  );
}

RequestChatButton.fragment = gql`
  fragment RequestChatButton on SiteUserProfile {
    ...RequestChatButtonDialog
  }
  ${RequestChatButtonDialog.fragment}
`;

// export const fragment = graphql(`
//   fragment RequestChatButton on Bottlebooks_SiteUserProfile {
//     ...RequestChatButtonDialog
//   }
// `);

export type RequestChatButtonData = RequestChatButtonDialogData & {};
